import React, { Component} from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';

const styles2 = (theme) => ({
  appBarSpacer: theme.mixins.toolbar
});

class IncidentResourcesPanel extends Component
{

  render()
  {
      let foundResources = this.props.incidentResources;

      return (
      <Dialog open={this.props.open} onClose={this.onRequestClose}>
      <AppBar color="primary" >
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={this.props.onRequestClose} aria-label="close">
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" >
           Incident Resources
         </Typography>
      </Toolbar>
      </AppBar>
      <div style={{marginTop: 40}}>
        <Table size="small" className={styles2.appBarSpacer}>
          <TableHead>
            <TableRow>
              <TableCell>Created</TableCell>
              <TableCell align="left">Created On</TableCell>
              <TableCell align="left">Modified</TableCell>
              <TableCell align="left">Modified On</TableCell>
              <TableCell align="left">Agency</TableCell>
              <TableCell align="left">Category</TableCell>
              <TableCell align="left">Kind</TableCell>
              <TableCell align="left">Personnel</TableCell>
              <TableCell align="left">Provider</TableCell>
              <TableCell align="left">Quantity </TableCell>
              <TableCell align="left">Quantity Current</TableCell>
              <TableCell align="left">Status</TableCell>
              <TableCell align="left">Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {foundResources.map(row => (
              //{moment(this.state.selectedIncident.attributes[originFields.createdOnDateTime]).format("MM/DD/YYYY [at] h:mm A")}
              <TableRow >
                <TableCell component="th" scope="row">{row.attributes["CreatedBySystem"]}</TableCell>
                <TableCell align="left">{moment(row.attributes["CreatedOnDateTime"]).format("MM/DD/YYYY h:mm A")}</TableCell>
                <TableCell align="left">{row.attributes["ModifiedBySystem"]}</TableCell>
                <TableCell align="left">{moment(row.attributes["ModifiedOnDateTime"]).format("MM/DD/YYYY h:mm A")}</TableCell>
                <TableCell align="left">{row.attributes["ResourceAgency"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourceCategory"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourceKind"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourcePersonnelQuantity"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourceProvider"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourceQuantity"]}</TableCell>
                <TableCell align="left">{moment(row.attributes["ResourceQuantityCurrentAsOf"]).format("MM/DD/YYYY h:mm A")}</TableCell>
                <TableCell align="left">{row.attributes["ResourceStatus"]}</TableCell>
                <TableCell align="left">{row.attributes["ResourceType"]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
        </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  selectedIncident: state.selectedIncident,
  parentIncident:  state.parentIncident,
  childIncidents: state.childIncidents
})

export default connect(mapStateToProps) (IncidentResourcesPanel)
